import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./PrimaryButton.scss";

const PrimaryButton = ({ children, className, ...rest }) => (
	<button
		{...rest}
		className={classnames(`primary-button ${className}`)}
	>
		{children}
	</button>
);

PrimaryButton.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

PrimaryButton.defaultProps = {
	className: null,
};

export default PrimaryButton;



// WEBPACK FOOTER //
// ./src/shared/components/PrimaryButton/PrimaryButton.jsx